import { render, staticRenderFns } from "./ToTokPayTerms.vue?vue&type=template&id=74ff468f&scoped=true"
import script from "./ToTokPayTerms.vue?vue&type=script&lang=js"
export * from "./ToTokPayTerms.vue?vue&type=script&lang=js"
import style0 from "./ToTokPayTerms.vue?vue&type=style&index=0&id=74ff468f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff468f",
  null
  
)

export default component.exports